import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {environment} from '../environments/environment';
import {SessionTopic} from '../model/session.model';
import {RemoteConfig} from '../app/config/remote-config';
import {SessionDTO} from '@minutespourtoi/api-models/dist/models';


@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private http = inject(HttpClient)
  private remoteConfig = inject(RemoteConfig)

  session(sessionId: string) {
    return firstValueFrom(this.http.get(`${environment.apiUrl}/api/sessions/${sessionId}`, {
      transferCache: false
    })) as Promise<SessionDTO>
  }

  async topicOfSession(session: SessionDTO) {
    let topic: SessionTopic = null
    if(session) {
      const topics = await this.remoteConfig.getObject<Array<SessionTopic>>("sessionTopics");
      return topics.find(t => t.name === (session.topic || 'none'));
    }
    return topic
  }

}
